import { AssessmentQuestion } from "../questionTypes";

// Business Profile Questions - To be updated
export const businessProfileQuestions: AssessmentQuestion[] = [
  // Questions will be added here
];
